import React from "react";
import { Badge } from "react-bootstrap";

import { GameFeaturingPromoState, useChoiceLabel } from "@/const";

export default function GameFeaturingPromoStateDisplay({ state }) {
    const GameFeaturingPromoStateTrans = useChoiceLabel("GameFeaturingPromoState");
    switch (state) {
        case GameFeaturingPromoState.NEW:
            return <Badge variant="secondary">{GameFeaturingPromoStateTrans[state]}</Badge>;
        case GameFeaturingPromoState.APPROVED:
            return <Badge variant="success">{GameFeaturingPromoStateTrans[state]}</Badge>;
        case GameFeaturingPromoState.REJECTED:
            return <Badge variant="danger">{GameFeaturingPromoStateTrans[state]}</Badge>;
        case GameFeaturingPromoState.MODERATE:
            return <Badge variant="warning">{GameFeaturingPromoStateTrans[state]}</Badge>;
        case GameFeaturingPromoState.POSTMODERATE:
            return <Badge variant="warning">{GameFeaturingPromoStateTrans[state]}</Badge>;
        case GameFeaturingPromoState.PUBLISHED:
            return <Badge variant="success">{GameFeaturingPromoStateTrans[state]}</Badge>;
        case GameFeaturingPromoState.FINISHED:
            return <Badge variant="secondary">{GameFeaturingPromoStateTrans[state]}</Badge>;
        default:
            return null;
    }
}
